export default "__VITE_PUBLIC_ASSET__5479c779__"